<template>
  <div
    class="bg-background-light dark:bg-background-dark font-display text-slate-900 dark:text-slate-100 overflow-x-hidden"
  >
    <div class="relative flex h-auto min-h-screen w-full flex-col">
      <header
        class="fixed top-0 left-0 right-0 z-50 w-full bg-white dark:bg-background-dark border-b border-primary/10 px-6 lg:px-20 py-4"
      >
        <div class="max-w-7xl mx-auto flex items-center justify-between gap-6">
          <RouterLink class="flex items-center gap-3" to="/">
            <div class="size-10 bg-primary flex items-center justify-center rounded-xl text-white">
              <span class="material-symbols-outlined text-2xl">local_shipping</span>
            </div>
            <h2 class="text-primary dark:text-white text-xl font-black tracking-tight uppercase">Guépard Express</h2>
          </RouterLink>
          <nav class="hidden md:flex flex-1 items-center justify-center gap-10 whitespace-nowrap">
            <a
              class="text-slate-700 dark:text-slate-300 text-sm font-semibold hover:text-primary transition-colors"
              href="#solutions"
              >Solutions</a>
            <a
              class="text-slate-700 dark:text-slate-300 text-sm font-semibold hover:text-primary transition-colors"
              href="#services"
              >Services</a>
            <a
              class="text-slate-700 dark:text-slate-300 text-sm font-semibold hover:text-primary transition-colors"
              href="#apropos"
              >À Propos</a>
            <a
              class="text-slate-700 dark:text-slate-300 text-sm font-semibold hover:text-primary transition-colors"
              href="#contact"
              >Contact</a>
          </nav>
          <div class="flex items-center gap-3">
            <template v-if="auth.isAuthenticated">
              <RouterLink
                class="hidden sm:flex min-w-[140px] cursor-pointer items-center justify-center rounded-lg h-11 px-5 bg-primary text-white text-sm font-bold shadow-lg shadow-primary/30 hover:shadow-primary/40 transition-all"
                to="/app/dashboard"
              >
                Mon Compte
              </RouterLink>
            </template>
            <template v-else>
              <RouterLink
                class="hidden sm:flex min-w-[120px] cursor-pointer items-center justify-center rounded-lg h-11 px-5 border-2 border-primary/20 hover:border-primary text-primary dark:text-white text-sm font-bold transition-all bg-white/70 hover:bg-white"
                to="/login"
                >Connexion</RouterLink
              >
              <RouterLink
                class="hidden sm:flex min-w-[170px] cursor-pointer items-center justify-center rounded-lg h-11 px-6 bg-primary text-white text-sm font-bold shadow-lg shadow-primary/30 hover:shadow-primary/40 transition-all"
                to="/login"
                >Gérer Mes Colis</RouterLink
              >
            </template>
            <button
              class="sm:hidden size-11 cursor-pointer items-center justify-center rounded-lg border border-primary/15 bg-white/70 hover:bg-white text-primary dark:bg-slate-900/40 dark:hover:bg-slate-900/60 dark:text-white transition-all flex"
              type="button"
              @click="isMenuOpen = !isMenuOpen"
            >
              <span class="material-symbols-outlined text-2xl">{{ isMenuOpen ? 'close' : 'menu' }}</span>
            </button>
          </div>
        </div>
        <div v-if="isMenuOpen" class="md:hidden max-w-7xl mx-auto px-2 pt-4">
          <div class="rounded-2xl border border-primary/10 bg-white/80 dark:bg-slate-900/50 backdrop-blur-md p-4">
            <div class="grid grid-cols-2 gap-3 text-sm font-semibold">
              <a class="rounded-lg px-3 py-2 hover:bg-primary/5 hover:text-primary transition-colors" href="#solutions"
                >Solutions</a
              >
              <a class="rounded-lg px-3 py-2 hover:bg-primary/5 hover:text-primary transition-colors" href="#services"
                >Services</a
              >
              <a class="rounded-lg px-3 py-2 hover:bg-primary/5 hover:text-primary transition-colors" href="#apropos"
                >À Propos</a
              >
              <a class="rounded-lg px-3 py-2 hover:bg-primary/5 hover:text-primary transition-colors" href="#contact"
                >Contact</a
              >
            </div>
            <div class="mt-4 flex gap-3">
              <template v-if="auth.isAuthenticated">
                <RouterLink
                  class="flex-1 h-11 rounded-lg bg-primary text-white font-bold shadow-lg shadow-primary/30 flex items-center justify-center"
                  to="/app/dashboard"
                >
                  Mon Compte
                </RouterLink>
              </template>
              <template v-else>
                <RouterLink
                  class="flex-1 h-11 rounded-lg border border-primary/20 text-primary dark:text-white font-bold hover:border-primary transition-all flex items-center justify-center"
                  to="/login"
                >
                  Connexion
                </RouterLink>
                <RouterLink
                  class="flex-1 h-11 rounded-lg bg-primary text-white font-bold shadow-lg shadow-primary/30 flex items-center justify-center"
                  to="/login"
                >
                  Gérer Mes Colis
                </RouterLink>
              </template>
            </div>
          </div>
        </div>
      </header>

      <main class="flex-1 pt-20">
        <section class="relative w-full overflow-hidden">
          <div class="absolute inset-0">
            <img
              alt="Modern Truck"
              class="h-full w-full object-cover object-right"
              src="https://lh3.googleusercontent.com/aida-public/AB6AXuBY4cxeAqaPutf6Boko4jhkJSD6X7zTQJp4_CYxbOTF6T3cyd1ygKm10hSbuHOZKNVVvWge5_6FLbnUgj-fVACGwbSyISE5g3ahcfDRkI7hYp0NXMuk2gz1d8aR_R6RVhf2XOBx0uJytb-20aPs6cUWL4wIwiEyJn7IT38RKWu1qMQsjCBfnyS-9y5HQ76BN1tagPu53C_0WAxLSQ-7iFq6G1SpAB06Mc5qHAprgCcP67dYSSZfCmlUibmj-crW7GNmDl08p_VNsTcY"
            />
            <div class="absolute inset-0 bg-gradient-to-r from-primary/95 via-primary/45 to-transparent"></div>
          </div>
          <div class="relative z-10 max-w-7xl mx-auto px-6 lg:px-20">
            <div class="min-h-[520px] md:min-h-[600px] py-20 md:py-24 flex items-center">
              <div class="max-w-2xl space-y-8">
                <div
                  class="inline-flex items-center gap-2 bg-white/10 backdrop-blur-md px-4 py-2 rounded-full border border-white/20 text-white text-xs font-bold uppercase tracking-widest"
                >
                  <span class="material-symbols-outlined text-sm">bolt</span>
                  Le Futur de la Réexpédition
                </div>
                <h1 class="text-white text-5xl md:text-7xl font-black leading-[0.95] tracking-tight">
                  <span class="block">Réexpédition de</span>
                  <span class="block">Colis <span class="text-white/70">Modernisée</span></span>
                </h1>
                <p class="text-white/90 text-base md:text-lg font-medium leading-relaxed max-w-xl">
                  Découvrez la réexpédition de colis simplifiée : scan automatique, notifications instantanées, comparaison
                  des transporteurs et suivi en temps réel pour une expérience sans effort.
                </p>
                <div class="flex flex-col sm:flex-row gap-4 pt-2">
                  <RouterLink
                    class="h-12 sm:h-14 px-8 bg-primary text-white rounded-lg font-bold shadow-lg shadow-primary/30 flex items-center justify-center"
                    :to="auth.isAuthenticated ? '/app/dashboard' : '/login'"
                    >Gérer Mes Colis</RouterLink
                  >
                  <RouterLink
                    class="h-12 sm:h-14 px-8 bg-white/10 backdrop-blur-md border border-white/30 text-white rounded-lg font-bold hover:bg-white/15 transition-colors flex items-center justify-center"
                    :to="auth.isAuthenticated ? '/app/dashboard' : '/login'"
                    >Voir le Portail</RouterLink
                  >
                </div>
              </div>
            </div>
          </div>
        </section>

        <section class="py-16 bg-white dark:bg-background-dark border-b border-primary/5">
          <div class="max-w-7xl mx-auto px-6 lg:px-20">
            <div class="grid grid-cols-1 md:grid-cols-3 gap-8">
              <div class="rounded-2xl border border-primary/10 bg-background-light/40 dark:bg-slate-900/30 p-8 text-center">
                <div class="mx-auto mb-3 size-12 rounded-xl bg-primary/10 text-primary flex items-center justify-center">
                  <span class="material-symbols-outlined text-2xl">inventory_2</span>
                </div>
                <h3 class="text-5xl font-black text-primary tracking-tight">10k+</h3>
                <p class="text-slate-500 dark:text-slate-400 font-semibold uppercase tracking-wider text-sm mt-2">
                  Colis Traité
                </p>
              </div>
              <div class="rounded-2xl border border-primary/10 bg-background-light/40 dark:bg-slate-900/30 p-8 text-center">
                <div class="mx-auto mb-3 size-12 rounded-xl bg-primary/10 text-primary flex items-center justify-center">
                  <span class="material-symbols-outlined text-2xl">local_shipping</span>
                </div>
                <h3 class="text-5xl font-black text-primary tracking-tight">500k+</h3>
                <p class="text-slate-500 dark:text-slate-400 font-semibold uppercase tracking-wider text-sm mt-2">
                  Réexpéditions Réussies
                </p>
              </div>
              <div class="rounded-2xl border border-primary/10 bg-background-light/40 dark:bg-slate-900/30 p-8 text-center">
                <div class="mx-auto mb-3 size-12 rounded-xl bg-primary/10 text-primary flex items-center justify-center">
                  <span class="material-symbols-outlined text-2xl">thumb_up</span>
                </div>
                <h3 class="text-5xl font-black text-primary tracking-tight">99%</h3>
                <p class="text-slate-500 dark:text-slate-400 font-semibold uppercase tracking-wider text-sm mt-2">
                  Satisfaction Clients
                </p>
              </div>
            </div>
          </div>
        </section>

        <section id="solutions" class="py-24 bg-background-light dark:bg-background-dark">
          <div class="max-w-7xl mx-auto px-6 lg:px-20">
            <div class="text-center mb-20 space-y-4">
              <h2 class="text-4xl md:text-5xl font-black text-slate-900 dark:text-white">
                Pourquoi Choisir Guépard Express
              </h2>
              <div class="w-24 h-1.5 bg-primary mx-auto rounded-full"></div>
              <p class="text-slate-600 dark:text-slate-400 text-lg max-w-2xl mx-auto pt-2">
                Nous digitalisons totalement le processus de réexpédition pour vous faire gagner du temps et optimiser
                vos coûts d'envoi.
              </p>
            </div>
            <div class="grid grid-cols-1 md:grid-cols-3 gap-8">
              <div
                class="group bg-white dark:bg-slate-900/50 p-10 rounded-2xl border border-primary/10 hover:border-primary transition-all shadow-sm hover:shadow-xl hover:-translate-y-2"
              >
                <div
                  class="size-16 bg-primary/10 rounded-xl flex items-center justify-center text-primary mb-8 group-hover:bg-primary group-hover:text-white transition-all"
                >
                  <span class="material-symbols-outlined text-3xl">payments</span>
                </div>
                <h3 class="text-xl font-bold mb-4">Scan Automatique</h3>
                <p class="text-slate-600 dark:text-slate-400 leading-relaxed">
                  Chaque colis est scanné et associé à votre compte. Poids, dimensions et photo enregistrés
                  automatiquement pour une traçabilité parfaite.
                </p>
              </div>
              <div
                class="group bg-white dark:bg-slate-900/50 p-10 rounded-2xl border border-primary/10 hover:border-primary transition-all shadow-sm hover:shadow-xl hover:-translate-y-2"
              >
                <div
                  class="size-16 bg-primary/10 rounded-xl flex items-center justify-center text-primary mb-8 group-hover:bg-primary group-hover:text-white transition-all"
                >
                  <span class="material-symbols-outlined text-3xl">map</span>
                </div>
                <h3 class="text-xl font-bold mb-4">Comparaison Transporteurs</h3>
                <p class="text-slate-600 dark:text-slate-400 leading-relaxed">
                  Comparez instantanément les tarifs Colissimo, DHL, DPD. Choisissez le meilleur rapport prix/délais
                  pour vos réexpéditions.
                </p>
              </div>
              <div
                class="group bg-white dark:bg-slate-900/50 p-10 rounded-2xl border border-primary/10 hover:border-primary transition-all shadow-sm hover:shadow-xl hover:-translate-y-2"
              >
                <div
                  class="size-16 bg-primary/10 rounded-xl flex items-center justify-center text-primary mb-8 group-hover:bg-primary group-hover:text-white transition-all"
                >
                  <span class="material-symbols-outlined text-3xl">radar</span>
                </div>
                <h3 class="text-xl font-bold mb-4">Suivi Temps Réel</h3>
                <p class="text-slate-600 dark:text-slate-400 leading-relaxed">
                  Suivez vos colis en temps réel du scan à la livraison. Notifications automatiques à chaque étape clé
                  du processus.
                </p>
              </div>
            </div>
          </div>
        </section>

        <section id="apropos" class="py-24 bg-white dark:bg-background-dark overflow-hidden">
          <div id="services"></div>
          <div class="max-w-7xl mx-auto px-6 lg:px-20">
            <div class="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
              <div class="relative">
                <div class="absolute -top-10 -left-10 size-64 bg-primary/5 rounded-full blur-3xl"></div>
                <img
                  alt="Logistics center"
                  class="rounded-2xl shadow-2xl relative z-10 w-full h-[500px] object-cover"
                  data-alt="Modern logistics center with organized shipping containers and digital displays"
                  src="https://lh3.googleusercontent.com/aida-public/AB6AXuB0NzpChZSGbBToYHzOdV9RDX3ka5Deqx0Sr_ZhI754Jq9LKK5P_Dmw7ncOlNbdnbtZIc8KHkBxE9AKZOjCfX9FUqqIiKcnQ6s3sjuvaZVGEkzgUeBbVUnD0v1Gl8XXU47Z4z5dEZakbNEDghDbO2m5EYmkD1e42lFhSLhlg4OybdBmTJr7lisuj5SGxJniL1uQWN9WLl0QQQ-6CH8CO3INioQd8Gcd6gHVvymlpbF7cnilYecDo9o9VfwG9SrdRSZkm0USLmaVsOe4"
                />
              </div>
              <div class="space-y-12">
                <div>
                  <h2 class="text-4xl font-black mb-6">Comment Ça Marche</h2>
                  <p class="text-slate-600 dark:text-slate-400 text-lg">
                    Commencer avec Guépard Express est simple. Digitalisez votre réexpédition en quatre étapes faciles.
                  </p>
                </div>
                <div class="space-y-8">
                  <div class="flex gap-6">
                    <div class="flex flex-col items-center">
                      <div
                        class="size-12 rounded-full bg-primary text-white flex items-center justify-center font-bold text-lg"
                      >
                        1
                      </div>
                      <div class="w-px h-full bg-slate-200 dark:bg-slate-800 mt-4"></div>
                    </div>
                    <div class="pb-8">
                      <h4 class="text-xl font-bold mb-2">Réception du Colis</h4>
                      <p class="text-slate-600 dark:text-slate-400">
                        Votre colis arrive chez nous, est scanné automatiquement et associé à votre compte. Vous recevez
                        une notification instantanée.
                      </p>
                    </div>
                  </div>
                  <div class="flex gap-6">
                    <div class="flex flex-col items-center">
                      <div
                        class="size-12 rounded-full bg-primary text-white flex items-center justify-center font-bold text-lg"
                      >
                        2
                      </div>
                      <div class="w-px h-full bg-slate-200 dark:bg-slate-800 mt-4"></div>
                    </div>
                    <div class="pb-8">
                      <h4 class="text-xl font-bold mb-2">Choisir la Réexpédition</h4>
                      <p class="text-slate-600 dark:text-slate-400">
                        Sélectionnez un ou plusieurs colis depuis votre portail. Notre système calcule automatiquement
                        le poids total et compare les transporteurs.
                      </p>
                    </div>
                  </div>
                  <div class="flex gap-6">
                    <div class="flex flex-col items-center">
                      <div
                        class="size-12 rounded-full bg-primary text-white flex items-center justify-center font-bold text-lg"
                      >
                        3
                      </div>
                      <div class="w-px h-full bg-slate-200 dark:bg-slate-800 mt-4"></div>
                    </div>
                    <div>
                      <h4 class="text-xl font-bold mb-2">Paiement & Expédition</h4>
                      <p class="text-slate-600 dark:text-slate-400">
                        Choisissez votre transporteur, payez en ligne avec Stripe, et votre colis est expédié
                        immédiatement avec suivi automatique.
                      </p>
                    </div>
                  </div>
                  <div class="flex gap-6">
                    <div class="flex flex-col items-center">
                      <div
                        class="size-12 rounded-full bg-primary text-white flex items-center justify-center font-bold text-lg"
                      >
                        4
                      </div>
                    </div>
                    <div>
                      <h4 class="text-xl font-bold mb-2">Livraison & Notifications</h4>
                      <p class="text-slate-600 dark:text-slate-400">
                        Recevez des notifications à chaque étape et suivez la livraison jusqu’à réception finale, sans
                        stress.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section class="py-20 px-6 lg:px-20 bg-primary overflow-hidden relative">
          <div class="absolute top-0 right-0 w-1/3 h-full bg-white/5 skew-x-12 transform translate-x-20"></div>
          <div class="absolute inset-0 bg-gradient-to-b from-white/0 via-white/0 to-black/10"></div>
          <div class="max-w-4xl mx-auto text-center relative z-10 space-y-8">
            <h2 class="text-4xl md:text-5xl font-black text-white">Prêt à digitaliser votre réexpédition ?</h2>
            <p class="bg-white/10 backdrop-blur-sm rounded-2xl p-6 text-white text-lg border border-white/15">
              Rejoignez des centaines de clients qui font confiance à Guépard Express pour une réexpédition rapide, fluide
              et fiable.
            </p>
            <div class="flex flex-col sm:flex-row gap-4 justify-center pt-4">
              <button
                class="h-16 px-10 bg-white text-primary rounded-xl font-black text-xl shadow-xl hover:-translate-y-0.5 transition-all"
              >
                Accéder au Portail
              </button>
              <button
                class="h-16 px-10 bg-primary border-2 border-white/40 text-white rounded-xl font-black text-xl hover:bg-white/10 hover:-translate-y-0.5 transition-all"
              >
                Contacter le Support
              </button>
            </div>
          </div>
        </section>
      </main>

      <footer id="contact" class="bg-white dark:bg-background-dark border-t border-primary/10 pt-20 pb-10">
        <div class="max-w-7xl mx-auto px-6 lg:px-20">
          <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-12 mb-16">
            <div class="lg:col-span-2 space-y-6">
              <div class="flex items-center gap-3">
                <div class="size-8 bg-primary flex items-center justify-center rounded text-white">
                  <span class="material-symbols-outlined text-xl">local_shipping</span>
                </div>
                <h2 class="text-primary dark:text-white text-lg font-black tracking-tight uppercase">Guépard Express</h2>
              </div>
              <p class="text-slate-500 dark:text-slate-400 max-w-sm">
                Le leader de la digitalisation du service de réexpédition. Automatisation complète du processus de
                réception, gestion et réexpédition de colis.
              </p>
              <div class="flex gap-4">
                <a
                  class="size-10 rounded-full border border-primary/20 flex items-center justify-center text-primary hover:bg-primary hover:text-white transition-all"
                  href="#"
                >
                  <span class="material-symbols-outlined text-xl">share</span>
                </a>
                <a
                  class="size-10 rounded-full border border-primary/20 flex items-center justify-center text-primary hover:bg-primary hover:text-white transition-all"
                  href="#"
                >
                  <span class="material-symbols-outlined text-xl">link</span>
                </a>
              </div>
            </div>
            <div>
              <h4 class="font-bold mb-6">Services</h4>
              <ul class="space-y-4 text-slate-500 dark:text-slate-400 text-sm">
                <li><a class="hover:text-primary transition-colors" href="#">Réexpédition</a></li>
                <li><a class="hover:text-primary transition-colors" href="#">Gros Volumes</a></li>
                <li><a class="hover:text-primary transition-colors" href="#">Tarifs</a></li>
                <li><a class="hover:text-primary transition-colors" href="#">Suivi Colis</a></li>
              </ul>
            </div>
            <div>
              <h4 class="font-bold mb-6">Entreprise</h4>
              <ul class="space-y-4 text-slate-500 dark:text-slate-400 text-sm">
                <li><a class="hover:text-primary transition-colors" href="#">À Propos</a></li>
                <li><a class="hover:text-primary transition-colors" href="#">Comment Ça Marche</a></li>
                <li><a class="hover:text-primary transition-colors" href="#">Blog</a></li>
                <li><a class="hover:text-primary transition-colors" href="#">Presse</a></li>
              </ul>
            </div>
            <div>
              <h4 class="font-bold mb-6">Support</h4>
              <ul class="space-y-4 text-slate-500 dark:text-slate-400 text-sm">
                <li><a class="hover:text-primary transition-colors" href="#">Centre d'Aide</a></li>
                <li><a class="hover:text-primary transition-colors" href="#">Sécurité</a></li>
                <li><a class="hover:text-primary transition-colors" href="#">Conditions d'Utilisation</a></li>
                <li><a class="hover:text-primary transition-colors" href="#">Politique de Confidentialité</a></li>
              </ul>
            </div>
          </div>
          <div class="mb-12 rounded-2xl border border-primary/10 bg-background-light/50 dark:bg-slate-900/30 p-8">
            <div class="flex flex-col lg:flex-row items-start lg:items-center justify-between gap-6">
              <div class="space-y-2">
                <h3 class="text-2xl font-black">Recevoir les nouveautés</h3>
                <p class="text-slate-600 dark:text-slate-400">
                  Promotions transporteurs, nouvelles fonctionnalités et conseils d’expédition.
                </p>
              </div>
              <form class="w-full lg:w-auto flex flex-col sm:flex-row gap-3">
                <input
                  class="h-12 w-full sm:w-80 rounded-xl border border-primary/15 bg-white dark:bg-slate-900/40 px-4 text-sm font-semibold outline-none focus:border-primary focus:ring-4 focus:ring-primary/10"
                  placeholder="Votre email"
                  type="email"
                />
                <button class="h-12 px-6 rounded-xl bg-primary text-white font-bold shadow-lg shadow-primary/30">
                  S'inscrire
                </button>
              </form>
            </div>
          </div>
          <div
            class="pt-10 border-t border-primary/5 flex flex-col md:flex-row justify-between items-center gap-6 text-slate-400 text-xs"
          >
            <p>© 2024 Guépard Express Logistics Inc. Tous droits réservés.</p>
            <div class="flex gap-8">
              <span>ISO 27001 Certified</span>
              <span>SOC2 Compliant</span>
            </div>
          </div>
        </div>
      </footer>
    </div>
  </div>
</template>

<script>
import { useAuthStore } from '@/stores/auth'

export default {
  name: 'FrontOfficeHomePage',
  data() {
    return {
      isMenuOpen: false
    }
  },
  computed: {
    auth() {
      return useAuthStore()
    }
  }
}
</script>
